import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../reducer/CombineReducer";
import { useUser } from "../../../../AuthContext";
import { BandingLandingPageView } from "./BandingLandingPage.view";
import { FetchBandingDetails } from "./Script";

/**
 * Responsible for rendering landing page of banding
 * @returns Banding Landing Page
 */
export const BandingLandingPage: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const selectedConfigId = outputConfig.selectedOutputConfig.id;
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  useEffect(() => {
    if (selectedConfigId)
      FetchBandingDetails(dispatch, translate, selectedConfigId, env, user?.token);
  }, [selectedConfigId]);

  return (
    <BandingLandingPageView />
  );
};
